import { motion } from "framer-motion";
import { Logo } from "./Logo";
import { scrollToId } from "./SmoothScroll";

const links = [["como-funciona", "Como funciona"], ["leituras", "Leituras"], ["sobre", "O ritual"]];

export const Header = ({ onBook }) => (
  <motion.header
    initial={{ y: -80 }}
    animate={{ y: 0 }}
    transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
    className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#080312]/60 backdrop-blur-xl"
  >
    <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:h-20 md:px-10">
      <Logo />
      <nav className="hidden items-center gap-10 md:flex">
        {links.map(([id, label]) => (
          <button key={id} data-testid={`nav-${id}`} onClick={() => scrollToId(id)}
            className="text-sm tracking-wide text-white/75 transition-colors duration-300 hover:text-[var(--gold)]">
            {label}
          </button>
        ))}
      </nav>
      <div className="flex items-center gap-4">
        {localStorage.getItem("maos_last_order") && (
          <a href={`/pedido/${localStorage.getItem("maos_last_order")}`} data-testid="header-my-order-link"
            className="text-xs uppercase tracking-[0.2em] text-white/75 transition-colors duration-300 hover:text-[#CBA365]">
            Meu pedido
          </a>
        )}
        <button data-testid="header-book-btn" onClick={() => onBook()}
        className="rounded-full border border-[#CBA365]/60 px-5 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--gold)] transition-colors duration-300 hover:bg-[var(--gold)] hover:text-[#080312]">
        Agendar
      </button>
      </div>
    </div>
  </motion.header>
);
